import { render, staticRenderFns } from "./btsb-chakan.vue?vue&type=template&id=a022ea64&scoped=true"
import script from "./btsb-chakan.vue?vue&type=script&lang=js"
export * from "./btsb-chakan.vue?vue&type=script&lang=js"
import style0 from "./btsb-chakan.vue?vue&type=style&index=0&id=a022ea64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a022ea64",
  null
  
)

export default component.exports